var _require = require('./styled-breakpoints'),
    createStyledBreakpoints = _require.createStyledBreakpoints,
    createTheme = _require.createTheme;

var _createStyledBreakpoi = createStyledBreakpoints(),
    up = _createStyledBreakpoi.up,
    down = _createStyledBreakpoi.down,
    only = _createStyledBreakpoi.only,
    between = _createStyledBreakpoi.between;

module.exports = {
  up: up,
  down: down,
  only: only,
  between: between,
  createTheme: createTheme
};